var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilePlusRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 80,
    viewBox: "0 0 60 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-plus-regular",
    d: "M57.078,14.591,45.417,2.928A10.046,10.046,0,0,0,38.344,0H10A10,10,0,0,0,0,10V70A10,10,0,0,0,10,80H50A10.029,10.029,0,0,0,60,70V21.656A10.007,10.007,0,0,0,57.078,14.591ZM52.5,70A2.5,2.5,0,0,1,50,72.5H10A2.5,2.5,0,0,1,7.5,70l0-59.98A2.5,2.5,0,0,1,10,7.52H35V20a5,5,0,0,0,5,5H52.5ZM33.75,34.859a3.753,3.753,0,0,0-7.5,0V43.75H17.5a3.722,3.722,0,0,0-3.75,3.609,3.631,3.631,0,0,0,3.75,3.609h8.75v8.75A3.812,3.812,0,0,0,30,63.75a3.722,3.722,0,0,0,3.75-3.609V51.109H42.5a3.612,3.612,0,1,0,0-7.219H33.75Z",
    fill: "#f36c21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlusRegular);
export default __webpack_public_path__ + "static/media/file-plus-regular.2586700b9744db2fc3d6e15919e1e50c.svg";
export { ForwardRef as ReactComponent };